import React, { FC, SVGProps } from 'react'

export const QuotesSvg: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillOpacity={0.48}
      d="M15.615 18.15c.183-3.88-2.403-6.155-4.154-7.047-.335-.171-.528-.55-.354-.883.41-.786 1.115-1.599 1.42-1.914.386-.399.514-1.064 0-1.463-.412-.32-1.03-.133-1.287 0-3.302 1.463-9.907 5.694-9.907 10.908 0 6.518 4.504 7.583 7.205 7.582 2.702 0 6.82-1.729 7.077-7.183ZM30.657 18.15c.184-3.88-2.402-6.155-4.153-7.047-.335-.171-.529-.55-.355-.883.41-.786 1.116-1.599 1.42-1.914.387-.399.515-1.064 0-1.463-.411-.32-1.029-.133-1.286 0-3.302 1.463-9.907 5.694-9.907 10.908 0 6.518 4.503 7.583 7.205 7.582 2.702 0 6.82-1.729 7.076-7.183Z"
    />
  </svg>
)
